import { Events } from './gallery';

class Progress {
    constructor(gallery) {
        this.gallery = gallery;
        this.progress = gallery.dom.progress;
        this.bufferProgress = gallery.dom.bufferProgress;
        this.gallery.addEventListener(Events.IndexChange, (index) => this.render(index));
        this.gallery.addEventListener(Events.IndexAboutToChange, (index) => this.render(index));
        this.gallery.addEventListener(Events.BufferChange, (buffer) => this.render(this.gallery.state.index, buffer));
        this.render();
    }

    render(index, bufferValue) {
        const buffer = bufferValue || this.gallery.bufferProcess();
        const length = this.gallery.length();

        const scale = index / (length - 1);
        this.progress.setAttribute('style', `transform: scale(${scale}, 1);`);

        this.bufferProgress.setAttribute('style', `transform: scale(${buffer}, 1);`);
    }
}

export default Progress;
